export default __webpack_public_path__ + "static/media/MS-HF24-Corex.41b2d08d.png";